const emojiReg = /\[(.+?)\]/g

export const CSEmojiObj = {
  // 第一排
  呲牙: {
    left: '-6',
    top: '-6'
  },
  cy: {
    left: '-6',
    top: '-6'
  },
  可爱: {
    left: '-36',
    top: '-6'
  },
  ka: {
    left: '-36',
    top: '-6'
  },
  发怒: {
    left: '-70',
    top: '-6'
  },
  fn: {
    left: '-70',
    top: '-6'
  },
  擦汗: {
    left: '-103',
    top: '-6'
  },
  ch: {
    left: '-103',
    top: '-6'
  },
  坏笑: {
    left: '-136',
    top: '-6'
  },
  huaix: {
    left: '-136',
    top: '-6'
  },
  惊恐: {
    left: '-169',
    top: '-6'
  },
  jk: {
    left: '-169',
    top: '-6'
  },
  流泪: {
    left: '-202',
    top: '-6'
  },
  ll: {
    left: '-202',
    top: '-6'
  },
  偷笑: {
    left: '-235',
    top: '-6'
  },
  tx: {
    left: '-235',
    top: '-6'
  },
  // 第二排
  调皮: {
    left: '-268',
    top: '-6'
  },
  tp: {
    left: '-268',
    top: '-6'
  },
  咒骂: {
    left: '-301',
    top: '-6'
  },
  zhm: {
    left: '-301',
    top: '-6'
  },
  委屈: {
    left: '-334',
    top: '-6'
  },
  wq: {
    left: '-334',
    top: '-6'
  },
  晕: {
    left: '-4',
    top: '-38'
  },
  yun: {
    left: '-4',
    top: '-38'
  },
  抓狂: {
    left: '-37',
    top: '-38'
  },
  zk: {
    left: '-37',
    top: '-38'
  },
  色: {
    left: '-70',
    top: '-38'
  },
  se: {
    left: '-70',
    top: '-38'
  },
  鄙视: {
    left: '-103',
    top: '-38'
  },
  bs: {
    left: '-103',
    top: '-38'
  },
  闭嘴: {
    left: '-136',
    top: '-38'
  },
  bz: {
    left: '-136',
    top: '-38'
  },
  // 第三排
  发呆: {
    left: '-169',
    top: '-38'
  },
  fd: {
    left: '-169',
    top: '-38'
  },
  困: {
    left: '-202',
    top: '-38'
  },
  kun: {
    left: '-202',
    top: '-38'
  },
  抠鼻: {
    left: '-235',
    top: '-38'
  },
  kb: {
    left: '-235',
    top: '-38'
  },
  阴险: {
    left: '-268',
    top: '-38'
  },
  yx: {
    left: '-268',
    top: '-38'
  },
  吐: {
    left: '-301',
    top: '-38'
  },
  tuu: {
    left: '-301',
    top: '-38'
  },
  奋斗: {
    left: '-334',
    top: '-38'
  },
  fendou: {
    left: '-334',
    top: '-38'
  },
  惊讶: {
    left: '-4',
    top: '-72'
  },
  jy: {
    left: '-4',
    top: '-72'
  },
  流汗: {
    left: '-36',
    top: '-72'
  },
  lh: {
    left: '-36',
    top: '-72'
  },
  // 第四排
  疑问: {
    left: '-69',
    top: '-72'
  },
  yiw: {
    left: '-69',
    top: '-72'
  },
  嘘: {
    left: '-102',
    top: '-72'
  },
  xu: {
    left: '-102',
    top: '-72'
  },
  冷汗: {
    left: '-135',
    top: '-72'
  },
  lengh: {
    left: '-135',
    top: '-72'
  },
  鼓掌: {
    left: '-168',
    top: '-72'
  },
  gz: {
    left: '-168',
    top: '-72'
  },
  哈欠: {
    left: '-201',
    top: '-72'
  },
  hq: {
    left: '-201',
    top: '-72'
  },
  憨笑: {
    left: '-234',
    top: '-72'
  },
  hanx: {
    left: '-234',
    top: '-72'
  },
  得意: {
    left: '-267',
    top: '-72'
  },
  dy: {
    left: '-267',
    top: '-72'
  },
  亲亲: {
    left: '-300',
    top: '-72'
  },
  qq: {
    left: '-300',
    top: '-72'
  },
  // 第五排
  睡: {
    left: '-333',
    top: '-72'
  },
  shui: {
    left: '-333',
    top: '-72'
  },
  右哼哼: {
    left: '-4',
    top: '-106'
  },
  yhh: {
    left: '-4',
    top: '-106'
  },
  左哼哼: {
    left: '-36',
    top: '-106'
  },
  zhh: {
    left: '-36',
    top: '-106'
  },
  折磨: {
    left: '-70',
    top: '-106'
  },
  zhem: {
    left: '-70',
    top: '-106'
  },
  快哭了: {
    left: '-103',
    top: '-106'
  },
  kk: {
    left: '-103',
    top: '-106'
  },
  可怜: {
    left: '-136',
    top: '-106'
  },
  kel: {
    left: '-136',
    top: '-106'
  },
  糗大了: {
    left: '-169',
    top: '-106'
  },
  qd: {
    left: '-169',
    top: '-106'
  },
  傲慢: {
    left: '-202',
    top: '-106'
  },
  am: {
    left: '-202',
    top: '-106'
  },
  // 第六排
  吓: {
    left: '-235',
    top: '-106'
  },
  xia: {
    left: '-235',
    top: '-106'
  },
  酷: {
    left: '-268',
    top: '-106'
  },
  kuk: {
    left: '-268',
    top: '-106'
  },
  大兵: {
    left: '-301',
    top: '-106'
  },
  db: {
    left: '-301',
    top: '-106'
  },
  饥饿: {
    left: '-334',
    top: '-106'
  },
  jie: {
    left: '-334',
    top: '-106'
  },
  衰: {
    left: '-4',
    top: '-140'
  },
  shuai: {
    left: '-4',
    top: '-140'
  },
  骷髅: {
    left: '-37',
    top: '-140'
  },
  kl: {
    left: '-37',
    top: '-140'
  },
  强: {
    left: '-70',
    top: '-140'
  },
  qiang: {
    left: '-70',
    top: '-140'
  },
  弱: {
    left: '-103',
    top: '-140'
  },
  ruo: {
    left: '-103',
    top: '-140'
  },
  // 第七排
  敲打: {
    left: '-136',
    top: '-140'
  },
  qiao: {
    left: '-136',
    top: '-140'
  },
  心碎: {
    left: '-169',
    top: '-140'
  },
  xs: {
    left: '-169',
    top: '-140'
  },
  握手: {
    left: '-202',
    top: '-140'
  },
  ws: {
    left: '-202',
    top: '-140'
  },
  胜利: {
    left: '-235',
    top: '-140'
  },
  shl: {
    left: '-235',
    top: '-140'
  },
  差劲: {
    left: '-268',
    top: '-140'
  },
  cj: {
    left: '-268',
    top: '-140'
  },
  NO: {
    left: '-301',
    top: '-140'
  },
  bu: {
    left: '-301',
    top: '-140'
  },
  拳头: {
    left: '-334',
    top: '-140'
  },
  qt: {
    left: '-334',
    top: '-140'
  },
  菜刀: {
    left: '-4',
    top: '-174'
  },
  cd: {
    left: '-4',
    top: '-174'
  },
  // 第八排
  炸弹: {
    left: '-37',
    top: '-174'
  },
  zhd: {
    left: '-37',
    top: '-174'
  },
  便便: {
    left: '-70',
    top: '-174'
  },
  bb: {
    left: '-70',
    top: '-174'
  },
  篮球: {
    left: '-103',
    top: '-174'
  },
  lq: {
    left: '-103',
    top: '-174'
  },
  足球: {
    left: '-136',
    top: '-174'
  },
  zq: {
    left: '-136',
    top: '-174'
  },
  闪电: {
    left: '-169',
    top: '-174'
  },
  shd: {
    left: '-169',
    top: '-174'
  },
  猪头: {
    left: '-202',
    top: '-174'
  },
  zt: {
    left: '-202',
    top: '-174'
  },
  乒乓: {
    left: '-235',
    top: '-174'
  },
  pp: {
    left: '-235',
    top: '-174'
  }
}

const string2Emoji = (text) => {
  // console.log(text)
  const newText = text?.replace(emojiReg, ($1) => {
    const t = $1.replace(/\[|\]/gi, '')
    const emojiArr = Object.keys(CSEmojiObj)
    // console.log($1, t)
    if (emojiArr.indexOf(t) > -1) {
      const data = CSEmojiObj[t]
      return `<span class="chatroom_emoji" style="background-position: ${data.left}px ${data.top}px;"></span>`
    }
    return $1
  })
  return newText
}

export default string2Emoji
